import * as types from './constants';

const initialState = {
  data: {},
  archiveLoading: false,
  errors_api: {}
};

const actions = {
  // Archive Assignment
  [types.ARCHIVE_ASSIGNMENT_REQUEST]: state => {
    const data = {
      ...state,
      archiveLoading: true
    };

    return { ...data };
  },

  [types.ARCHIVE_ASSIGNMENT_DONE]: (state, { payload }) => {
    const data = {
      ...state,
      data: payload,
      archiveLoading: false
    };

    return { ...data };
  },

  [types.ARCHIVE_ASSIGNMENT_FAILED]: (state, { payload }) => {
    const data = {
      ...state,
      archiveLoading: false,
      errors_api: payload
    };

    return { ...data };
  }
};

export default (state = initialState, action) => {
  if (actions[action.type]) return actions[action.type](state, action);
  return state;
};